module.exports = __webpack_public_path__ + "static/media/beer_icon_red.d962ca90.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/beer_icon_red.png
// module id = 94
// module chunks = 0